<script setup lang="ts">
const props = withDefaults(
  defineProps<{ type?: 'maintenance' | 'currently-playing' }>(),
  {
    type: 'currently-playing',
  },
);

const dotAfterColour = computed(() =>
  props.type === 'maintenance'
    ? 'after:bg-gold-500'
    : 'after:bg-primary-blue-gradient',
);

const dotBeforeColour = computed(() =>
  props.type === 'maintenance'
    ? 'beforebg-[linear-gradient(45deg,#d87700_0%,#ffc018)]'
    : 'before:bg-primary-blue-gradient',
);

const badgeText = computed(() =>
  props.type === 'maintenance' ? 'in-maintenance' : 'active',
);
</script>
<template>
  <div
    class="bg-[#ffffff]/50 dark:bg-[#1d2129]/50 absolute h-full w-full flex justify-center items-center z-1 text-base-priority"
  >
    <div
      class="flex items-center bg-layer p-1 rounded-md text-xs md:text-normal"
    >
      <div
        :class="[
          'dot w-3 h-3 flex-center relative mr-1 text-xs',
          `before:content-[' ']`,
          dotBeforeColour,
          `after:content-[' ']`,
          dotAfterColour,
        ]"
      >
        {{ '' }}
      </div>
      <strong>
        {{ $t(badgeText) }}
      </strong>
    </div>
  </div>
</template>
<style scoped lang="scss">
.dot::before {
  @apply animate-pulse w-2 h-2 absolute rounded-full;
}
.dot::after {
  @apply absolute h-3 w-3 rounded-full opacity-25;
}
</style>
